module.exports = __webpack_public_path__ + "static/media/btn-back.cd4eba9f.svg";